import { render, staticRenderFns } from "./ApprovalCompleted.vue?vue&type=template&id=a7bceaec&scoped=true&"
import script from "./ApprovalCompleted.vue?vue&type=script&lang=js&"
export * from "./ApprovalCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bceaec",
  null
  
)

export default component.exports